import React from "react";

export const PrescricaoICon = ({
  size = "32",
  className,
}: {
  size?: string;
  className?: string;
}) => {
  return (
    <svg
      height={size}
      className={className}
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 443.1 512"
    >
      <path
        d="M32,464V48c0-8.8,7.2-16,16-16h240v64c0,17.7,14.3,32,32,32h64v33c0,8.3,6.7,15,15,15h2c8.3,0,15-6.7,15-15v-49
		c0-4.3-1.6-8.3-4.6-11.4l-96-96c-3-3-7.1-4.7-11.4-4.6H48C21.5,0,0,21.5,0,48v416c0,26.5,21.5,48,48,48h97c8.3,0,15-6.7,15-15v-2
		c0-8.3-6.7-15-15-15H48C39.2,480,32,472.8,32,464z"
      />
      <path
        d="M116,251.9c0,22.5,8.8,43.7,24.7,59.7l75.6,75.6l75.6,75.6c15.9,15.9,37.1,24.7,59.7,24.7s43.7-8.8,59.7-24.7
		c15.9-15.9,24.7-37.1,24.7-59.7s-8.8-43.7-24.7-59.7l-75.6-75.6l-75.6-75.6c-15.9-15.9-37.1-24.7-59.7-24.7
		c-22.5,0-43.7,8.8-59.7,24.7C124.8,208.2,116,229.4,116,251.9z M240.2,379.2l87.5-87.5l67.6,67.6c11.7,11.7,18.1,27.2,18.1,43.8
		s-6.4,32.1-18.1,43.8S368.1,465,351.6,465c-16.5,0-32.1-6.4-43.8-18.1L240.2,379.2z M138.5,251.9c0-16.5,6.4-32.1,18.1-43.8
		s27.2-18.1,43.8-18.1c16.5,0,32.1,6.4,43.8,18.1l67.6,67.6l-87.5,87.5l-67.6-67.6C145,284,138.5,268.4,138.5,251.9z"
      />
      <path
        d="M164,241.4c-5.1-3.5-6.4-10.5-2.9-15.6c9.5-13.8,25.1-22.1,41.8-22.1c13.5,0,26.2,5.3,35.8,14.8c4.4,4.4,4.4,11.5,0,15.9
		c-4.4,4.4-11.5,4.4-15.9,0c-5.3-5.3-12.4-8.2-19.9-8.2c-9.3,0-18,4.6-23.2,12.3c-2.2,3.2-5.7,4.9-9.3,4.9
		C168.1,243.4,165.9,242.7,164,241.4z"
      />
    </svg>
  );
};
